import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import EmployeeStat from 'modules/attendance/store/models/EmployeeStat'

class EmployeeStats extends Collection<EmployeeStat> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      employeeIds: computed,
    })
  }

  get cacheKey(): string {
    return 'employeeStats'
  }

  model() {
    return EmployeeStat
  }

  get indexes() {
    return ['state']
  }

  get employeeIds(): string[] {
    return this.models.map((stat: EmployeeStat) => stat.get('employee_id'))
  }
}

const singleton: EmployeeStats = new EmployeeStats()

export default singleton
